/*
 * @Author: jiakaiwen jiakaiwen@huihaiyinhe.com
 * @Date: 2025-12-10 09:34:34
 * @LastEditors: jiakaiwen jiakaiwen@huihaiyinhe.com
 * @LastEditTime: 2025-12-30 10:23:56
 */
import React from 'react'
import type { Dayjs } from 'dayjs'
import { QuickPickerItem } from '../../types'

type QuickFilterListProps = {
  items: QuickPickerItem[]
  onSelect: (startTime: Dayjs, endTime: Dayjs, item: QuickPickerItem) => void
  /** 按人员模式下禁用整组快捷日期 */
  disabled?: boolean
}

const QuickFilterList: React.FC<QuickFilterListProps> = ({
  items,
  onSelect,
  disabled = false
}) => {
  if (!items || items.length === 0) {
    return null
  }

  return (
    <div className="pfv2-quick-filter">
      <div
        className={`pfv2-quick-list${
          disabled ? ' pfv2-quick-list--disabled' : ''
        }`}
      >
        {items.map((item, index) => (
          <span
            key={`${item.clickItem}-${index}`}
            className="pfv2-quick-item"
            onClick={() => {
              if (disabled) return
              onSelect(item.startTime(), item.endTime(), item)
            }}
          >
            {item.text}
          </span>
        ))}
      </div>
    </div>
  )
}

export default QuickFilterList
